import Vue from 'vue';

const success = (response, resolve) => {
  resolve(response);
};

const failed = (error, reject) => {
  reject(error);
};

export default productId => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/products/${productId}/marketplace`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/marketplaceProduct/destroy.js